interface LabelCaseProps {
  label: string;
}

const LabelCase = ({ label }: LabelCaseProps) => {
  return (
    <p
      style={{
        margin: 0,
        marginBottom: "var(--width-24)",
        color: "#fff",
        fontFamily: "Tungsten",
        fontSize: "var(--width-40)",
        fontStyle: "normal",
        fontWeight: "500",
        textTransform: "uppercase",
      }}
    >
      {label}
    </p>
  );
};

export default LabelCase;
